/**
 * EmailTemplate entity validation rules.
 */

import { getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

const CONTENT_TYPE_WARNING =
    'Email templates should use "text/html" as ContentType. Other values may cause rendering issues.';

/**
 * Returns validation warnings for EmailTemplate entity data.
 */
export function getEmailTemplateWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];
    const contentType = getEntityAttrString(data, 'ContentType').toLowerCase();
    if (contentType && contentType !== 'text/html' && contentType !== 'html') {
        warnings.push({
            message: CONTENT_TYPE_WARNING,
            severity: 'warning',
            attributeDisplayNames: ['ContentType']
        });
    }

    const subject = getEntityAttrString(data, 'Subject').trim();
    if (!subject) {
        warnings.push({
            message: 'Email templates should have a Subject line.',
            severity: 'warning',
            attributeDisplayNames: ['Subject']
        });
    }

    const body = getEntityAttrString(data, 'Body').trim();
    if (!body) {
        warnings.push({
            message: 'Email template Body is empty.',
            severity: 'warning',
            attributeDisplayNames: ['Body']
        });
    } else if (!body.includes('[//')) {
        warnings.push({
            message: 'This template contains no dynamic variables (e.g. [//Target/DisplayName]).',
            severity: 'info',
            attributeDisplayNames: ['Body']
        });
    }

    return warnings;
}
